export default {
    // Common
    appConfig: {},
    currentBackground: null,
    currentAppSegment: null,

    // User
    currentUser: null,
    userToken: null,

    // Admin store
    activeIndicatorId: null,
    activeIndicatorData: null,


    // Scenario stuff
    activeScenario: null,
    activeScenarioData: null,
    scenarioIndicators: [],
    scenarioActiveChild: null,
    scenarioActiveAdult: null,
}
